import "bootstrap";
import objectFitImages from 'object-fit-images';
import './jquery.rwdImageMaps.min.js';

window.jQuery = $;
$(function () {
    // ofi
    objectFitImages();

    // jquery.rwdImageMaps.min.js for responsive clickable maps
    $('img[usemap]').rwdImageMaps();

    // touchイベントにhoverクラス付与
    $('.js_h')
      .on('mouseenter touchstart', function(){
         $(this).addClass('hover');
    }).on('mouseleave touchend', function(){
         $(this).removeClass('hover');
    });

    const topBtn = $('.pagetop');
	topBtn.hide();
	topBtn.click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 500);
		return false;
	});
	$(window).scroll(function () {
		if ($(this).scrollTop() > 200) {
			topBtn.fadeIn();
		} else {
			topBtn.fadeOut();
		}
	});
})